
import EazyHeading from '@/components/EazyHeading.vue';
import AssessmentProgressRow from '@/components/AssessmentProgressRow.vue';
import AssessmentsFilter from '@/components/AssessmentsFilter.vue';
import store from '@/store';
import router from '@/router';
import redirToProjectDetailsIfProject from '@/logic/redirToProjectDetailsIfProject';
import requestAPI from '@/logic/requestBeApi';
import assessmentsRequestService from '@/logic/services/assessmentsRequestService';
import assessmentsService from '@/logic/services/assessmentsService';
import helpToCreateNoPositionsLabel from '@/logic/helpers/helpToCreateNoPositionsLabel';
import trainingService from '@/logic/services/trainingService';
import TrainingProgressRow from '@/components/TrainingProgressRow.vue';
import getMeetingDateAndTime from '@/logic/helpers/dates/getMeetingDateAndTime';

export default {
  name: 'EventsList',

  components: {
    EazyHeading,
    AssessmentProgressRow,
    AssessmentsFilter,
    TrainingProgressRow,
  },

  props: {
    tasksView: Boolean,
    propMode: {
      type: String,
      default: '',
    },
    trainingId: {
      type: String,
      default: '',
    },
  },

  data(): Record<string, unknown> {
    return {
      device: store.state.device,
      projectsFilters: ['requests', 'ongoing', 'completed'],
      interviewsFilters: ['todoInterviews', 'ongoingInterviews', 'completedInterviews'],
      reportsFilters: ['todo', 'drafts', 'sent', 'approved'],
      trainingsFilters: ['active', 'complete', 'overall'],
      trainingSessionsFilters: ['passageOne', 'passageTwo', 'passageThree'],
      sessionsFilters: ['active', 'new', 'complete'],
      tasksFilters: [
        'overallTasksNumber',
        'criticalTasksNumber',
        'newTasksNumber',
        'completeTasksNumber',
      ],
      eventsSummary: '',
      assessedCandidates: 0,
      summaryHandlerAlreadyRunning: false,
      fetchingEventsSummary: false,
      projectEvents: [],
      userWhoCreatedData: {},
      trainings: {},
      getMeetingDateAndTime,
      trainingSessions: [],
      initailFilterDeleivered: false,
    };
  },

  computed: {
    activeUpcomingFilter(): string {
      return localStorage.getItem('activeUpcomingTab');
    },
    candidateId(): string {
      return localStorage.getItem('userId');
    },
    candidateTrainingSessions(): any[] {
      return this.$store.state.candidateTrainingSessions;
    },
    isCandidateTrainingView(): boolean {
      return (
        (this.userRole === 'candidate' || this.userRole === 'client') &&
        (this.mode === 'trainings' ||
          this.mode === 'upcoming' ||
          this.mode === 'tasks' ||
          this.mode === 'sessions')
      );
    },
    candidateTasks(): any[] {
      return this.$store.state.tasks;
    },
    userRole(): string {
      return store.state.userRole;
    },

    mode(): string {
      return this.propMode || this.$route.query.mode;
    },

    filter(): string {
      let filter = '';

      if (this.mode === 'projects') filter = store.state.assessmentsFilter.projects;
      else if (this.mode === 'interviews') filter = store.state.assessmentsFilter.interviews;
      else if (this.mode === 'reports') filter = store.state.assessmentsFilter.reports;
      else if (this.mode === 'trainings') filter = store.state.trainingsModeFilter.trainings;
      else if (this.mode === 'upcoming') filter = store.state.trainingsModeFilter.trainingSessions;
      else if (this.mode === 'tasks') filter = store.state.trainingsModeFilter.tasks;
      else if (this.mode === 'sessions') filter = store.state.trainingsModeFilter.sessions;
      return filter;
    },

    shouldRouteToCandidatePage(): boolean {
      return this.mode === 'interviews';
    },

    events: {
      get(): string {
        if (this.mode === 'projects') return store.state.projects;
        if (this.mode === 'interviews') return store.state.interviews;
        if (this.mode === 'reports') return store.state.reports;
        if (this.mode === 'trainings') return store.state.trainings;
        if (this.mode === 'upcoming') return store.state.trainingSessions;
        if (this.mode === 'tasks') return store.state.tasks;
        if (this.mode === 'sessions') return store.state.sessions;
        return '';
      },

      set(newVal: unknown): unknown {
        return newVal;
      },
    },
    eventsWithCreator(): any[] {
      if (
        this.mode === 'trainings' ||
        this.mode === 'upcoming' ||
        this.mode === 'tasks' ||
        this.mode === 'sessions'
      )
        return;
      return this.events.map((event) => {
        const userWhoCreated = this.userWhoCreatedData[event.id] || '';
        return { ...event, userWhoCreated };
      });
    },

    processingUserDataRequest: {
      get(): string {
        if (this.mode === 'projects') return store.state.projectsRequestPending;
        if (this.mode === 'interviews') return store.state.interviewsRequestPending;
        if (this.mode === 'reports') return store.state.reportsRequestPending;
        if (this.mode === 'trainings') return store.state.trainingsRequestPending;
        if (this.mode === 'upcoming') return store.state.trainingSessionsRequestPending;
        if (this.mode === 'tasks') return store.state.tasksRequestPending;
        return '';
      },

      set(newVal: unknown): unknown {
        return newVal;
      },
    },

    requestsOrDrafts(): boolean {
      return this.filter === 'requests' || this.filter === 'drafts';
    },

    reloadSpecificList(): string {
      return store.state.reloadSpecificList;
    },

    noPositionLabel(): string {
      return helpToCreateNoPositionsLabel(this);
    },

    numberOfEventsOnCurrentTab(): number {
      if (this.mode === 'upcoming') {
        return store.state.eventsNumber['trainingSessions'][this.filter];
      } else {
        return store.state.eventsNumber[this.mode][this.filter];
      }
    },
  },

  watch: {
    mode(): void {
      this.getEventsList();
      this.getEventsSummary(this.mode);
    },

    filter(): void {
      this.getEventsList();
      this.getEventsSummary(this.mode);
    },

    eventsSummary(): void {
      this.handleEventsSummary();
      this.summaryHandlerAlreadyRunning = true;

      setTimeout(() => {
        this.summaryHandlerAlreadyRunning = false;
      });

      setTimeout(() => {
        this.ifOnPageBottomLoadMoreEvents();
      }, 300);
    },

    reloadSpecificList(): void {
      if (this.reloadSpecificList) {
        if (this.projectsFilters.includes(this.reloadSpecificList) && this.mode === 'projects') {
          if (store.state.reloadingProjectsList) return;

          assessmentsRequestService.getRequests({
            self: this,
            filter: this.reloadSpecificList,
            reloadExisting: true,
          });
          store.commit('setReloadingProjectsList', true);

          setTimeout(() => {
            this.getEventsSummary('projects');
            store.commit('setReloadingProjectsList', false);
          }, 1);
        } else if (
          this.interviewsFilters.includes(this.reloadSpecificList) &&
          this.mode === 'interviews'
        ) {
          if (store.state.reloadingAssessmentsList) return;

          assessmentsService.getAssessments({
            self: this,
            filter: this.reloadSpecificList,
            reloadExisting: true,
          });
          store.commit('setReloadingAssessmentsList', true);

          setTimeout(() => {
            this.getEventsSummary('interviews');
            store.commit('setReloadingAssessmentsList', false);
          }, 1);
        } else if (
          this.reportsFilters.includes(this.reloadSpecificList) &&
          this.mode === 'reports'
        ) {
          if (store.state.reloadingReportsList) return;

          assessmentsService.getReports({
            self: this,
            filter: this.reloadSpecificList,
            reloadExisting: true,
          });
          store.commit('setReloadingReportsList', true);

          setTimeout(async () => {
            await this.getEventsSummary('reports');
            await this.getEventsSummary('projects');

            store.commit('setReloadingReportsList', false);
          }, 1);
        } else if (
          this.sessionsFilters.includes(this.reloadSpecificList) &&
          this.mode === 'sessions'
        ) {
          if (store.state.reloadingSessionsList) return;

          trainingService.getClientTrainingSessions({
            self: this,
            filter: this.reloadSpecificList,
            reloadExisting: true,
          });
          store.commit('setReloadingSessionsList', true);

          setTimeout(async () => {
            await this.getEventsSummary('sessions');
            store.commit('setReloadingSessionsList', false);
          }, 1);
        } else if (
          this.trainingSessionsFilters.includes(this.reloadSpecificList) &&
          this.mode === 'upcoming'
        ) {
          if (store.state.reloadingTrainingSessionsList) return;

          trainingService.getTrainingSessions({
            self: this,
            filter: this.reloadSpecificList,
            reloadExisting: true,
          });
          store.commit('setReloadingTrainingSessionsList', true);

          setTimeout(async () => {
            await this.getEventsSummary('upcoming');
            store.commit('setReloadingTrainingSessionsList', false);
          }, 1);
        } else if (this.tasksFilters.includes(this.reloadSpecificList) && this.mode === 'tasks') {
          if (store.state.reloadingTasksList) return;

          trainingService.getTasks({
            self: this,
            filter: this.reloadSpecificList,
            reloadExisting: true,
          });
          store.commit('setReloadingTasksList', true);

          setTimeout(async () => {
            await this.getEventsSummary('tasks');
            store.commit('setReloadingTasksList', false);
          }, 1);
        }
      }
    },
  },

  async created(): Promise<void> {
    this.getEventsList();
    this.getEventsSummary(this.mode);
    if (this.isCandidateTrainingView) {
      trainingService.getCandidateTrainings(this);
    }
  },

  async mounted(): Promise<void> {
    if (this.isCandidateTrainingView) {
      await this.getTrainings(this);
    }
    this.getCreateorsOfEvents();
    this.runLazyLoading();
  },

  beforeDestroy(): void {
    document.removeEventListener('scroll', this.ifOnPageBottomLoadMoreEvents);
  },

  methods: {
    handleActiveTrainingId(eventId: string): void {
      this.$emit('active-training-id', eventId);
    },
    async getTrainings(): Promise<void> {
      const response = await requestAPI({
        url: `/api/v1/trainings`,
        method: 'GET',
      });

      if (response.ok) {
        const data = await response.json();
        this.trainings = data;
      }
    },

    calculatePercentage(trainingSessions: any[]): number {
      if (trainingSessions.length === 0) {
        return 0;
      }
      const completedSessions = trainingSessions.filter(
        (session) => session.status === 'completed',
      );
      const percentage = (completedSessions.length / trainingSessions.length) * 100;
      return Math.round(percentage);
    },

    async getCreateorsOfEvents(): Promise<[any[], any[]]> {
      const projectsPromise = this.fetchUserWhoCreatedData('projects');
      const interviewsPromise = this.fetchUserWhoCreatedData('interviews');
      return Promise.all([projectsPromise, interviewsPromise]);
    },
    async fetchUserWhoCreatedData(mode: string): Promise<void> {
      if (this.$route.path === '/candidate-trainings' || this.userRole === 'client') return;
      const apiUrl =
        mode === 'projects' ? '/api/v1/assessors/me/assessment-requests' : '/api/v1/assessments';

      try {
        const response = await requestAPI({
          url: apiUrl,
          method: 'GET',
        });

        if (response.ok) {
          const responseData = await response.json();
          responseData.forEach((item) => {
            this.$set(this.userWhoCreatedData, item.id, item.created_by.type);
          });
        }
      } catch (error) {
        this.$message.error(this.$t('someErrorOccurred'));
      }
    },

    redirToProjectDetailsIfProject(projectId, projectStatus, assessorStatus): void {
      const tasksView = this.tasksView;
      const devide = this.device;
      const mode = this.mode;
      const userRole = this.userRole;

      redirToProjectDetailsIfProject(
        projectId,
        projectStatus,
        assessorStatus,
        mode,
        tasksView,
        devide,
        userRole,
        router,
        this,
      );
    },

    async getEventsSummary(mode: string, getAssessedCandidates: unknown): Promise<void> {
      if (this.mode === 'upcoming') {
        this.getUpcomingFilteredEventsSummary();
      } else {
        this.fetchingEventsSummary = true;
        let listToSend;

        if (mode === 'projects') listToSend = 'assessment-requests';
        if (mode === 'interviews') listToSend = 'assessments';
        if (mode === 'reports') listToSend = 'reports';
        if (mode === 'trainings') listToSend = 'trainings';
        if (mode === 'tasks') listToSend = 'candidate-training-sessions';
        if (mode === 'sessions') listToSend = 'training-sessions';

        const response = await requestAPI({ url: `/api/v1/${listToSend}/summary`, method: 'GET' });

        if (response.ok) {
          const data = await response.json();

          if (getAssessedCandidates) {
            this.fetchingEventsSummary = false;
            return data;
          }

          this.eventsSummary = data;
        } else if (response.status !== 401) this.$message.error(this.$t('someErrorOccurred'));
      }
      this.fetchingEventsSummary = false;
    },

    async getNumberOfAssessedCandidates(): Promise<void> {
      await this.getEventsSummary('interviews', 'getAssessedCandidates')
        .then((respJson: any[]) => {
          const assessedCandidates = respJson.find(
            (obj: { status: string }) => obj.status === 'assessed',
          );
          this.assessedCandidates = assessedCandidates ? assessedCandidates.count : 0;
        })
        .catch((err: Error) => err);
    },

    async getUpcomingFilteredEventsSummary(): Promise<void> {
      this.fetchingEventsSummary = true;
      const filters = ['passageOne', 'passageTwo', 'passageThree'];

      const summaryPromises = filters.map(async (filter) => {
        const dateFilter = trainingService.getDateFilter(filter);
        const response = await requestAPI({
          url: `/api/v1/training-sessions?${dateFilter}&order[created_at]=DESC`,
          method: 'GET',
        });

        if (response.ok) {
          const data = await response.json();
          const count = data.length;
          return {
            status: filter,
            count: count,
          };
        }
      });

      const upcomingTrainingSessionsSummary = await Promise.all(summaryPromises);
      this.eventsSummary = upcomingTrainingSessionsSummary;
      this.fetchingEventsSummary = false;
    },

    async handleEventsSummary(): Promise<void> {
      if (!this.eventsSummary || this.summaryHandlerAlreadyRunning) return;

      const mode = this.mode;
      let eventsNumber = [];

      if (mode === 'trainings') {
        const completedStatuses = ['cancelled', 'completed', 'post_work'];
        const ongoingStatuses = ['in_progress', 'new', 'pre_work'];
        const overall = this.eventsSummary;
        const active = overall.filter((event: { status: string }) =>
          ongoingStatuses.includes(event.status),
        );
        const complete = overall.filter((event: { status: string }) =>
          completedStatuses.includes(event.status),
        );

        eventsNumber[0] = overall.length ? this.countEvents(overall) : '';
        eventsNumber[1] = active.length ? this.countEvents(active) : '';
        eventsNumber[2] = complete.length ? this.countEvents(complete) : '';
      }
      if (this.userRole === 'client') {
        if (mode === 'sessions') {
          const completedStatuses = ['cancelled', 'completed'];
          const activeStatuses = ['in_progress'];
          const newStatuses = ['new', 'pre_work', 'post_work'];
          const overall = this.eventsSummary;
          const activeSessions = overall.filter((event: { status: string }) =>
            activeStatuses.includes(event.status),
          );
          const completeSessions = overall.filter((event: { status: string }) =>
            completedStatuses.includes(event.status),
          );
          const newSessions = overall.filter((event: { status: string }) =>
            newStatuses.includes(event.status),
          );

          eventsNumber[0] = activeSessions.length ? this.countEvents(activeSessions) : '';
          eventsNumber[1] = completeSessions.length ? this.countEvents(completeSessions) : '';
          eventsNumber[2] = newSessions.length ? this.countEvents(newSessions) : '';
        }
      }

      if (mode === 'tasks') {
        const completedStatuses = ['accepted', 'results_uploaded'];
        const activeStatuses = ['in_progress'];
        const criticalStatuses = ['missed', 'rejected'];
        const active = this.eventsSummary.filter((event: { status: string }) =>
          activeStatuses.includes(event.status),
        );
        const complete = this.eventsSummary.filter((event: { status: string }) =>
          completedStatuses.includes(event.status),
        );
        const critical = this.eventsSummary.filter((event: { status: string }) =>
          criticalStatuses.includes(event.status),
        );

        eventsNumber[0] = critical.length ? this.countEvents(critical) : '';
        eventsNumber[1] = complete.length ? this.countEvents(complete) : '';
        eventsNumber[2] = active.length ? this.countEvents(active) : '';
      }

      if (mode === 'upcoming') {
        eventsNumber = this.eventsSummary.map((item) => item.count);
        const overall = eventsNumber.reduce((sum, count) => sum + count, 0);
        eventsNumber.push(overall);
        const passageNames = ['passageOne', 'passageTwo', 'passageThree'];
        if (!this.initailFilterDeleivered) {
          this.findAndApplyActivePassage(eventsNumber, passageNames, store);
          this.initailFilterDeleivered = true;
        }
      }

      if (this.userRole === 'assessor') {
        if (mode === 'projects') {
          const nonOverallStatuses = [
            'assessors_matched',
            'completed',
            'cancelled',
            'expired',
            'invoices_sent',
          ];
          const overall = this.eventsSummary.filter(
            (event: { status: string }) => !nonOverallStatuses.includes(event.status),
          );
          const requests = overall.filter(
            (event: { status: string }) => event.status !== 'confirmed',
          );
          const ongoing = overall.filter(
            (event: { status: string }) => event.status === 'confirmed',
          );

          eventsNumber[0] = overall.length ? this.countEvents(overall) : '';
          eventsNumber[1] = requests.length ? this.countEvents(requests) : '';
          eventsNumber[2] = ongoing.length ? this.countEvents(ongoing) : '';
        }

        if (mode === 'interviews') {
          const completedStatuses = [
            'completed',
            'published',
            'assessed',
            'cancelled',
            'expired',
            'request_expired',
          ];
          const ongoingStatuses = [
            'confirmed',
            'in_progress',
            'invited',
            'accepted',
            'cancelled_by_candidate',
          ];
          const overall = this.eventsSummary.filter(
            (event: { status: string }) => !completedStatuses.includes(event.status),
          );
          const todoInterviews = overall.filter(
            (event: { status: string }) => event.status === 'new',
          );
          const ongoingInterviews = overall.filter((event: { status: string }) =>
            ongoingStatuses.includes(event.status),
          );

          eventsNumber[0] = overall.length ? this.countEvents(overall) : '';
          eventsNumber[1] = todoInterviews.length ? this.countEvents(todoInterviews) : '';
          eventsNumber[2] = ongoingInterviews.length ? this.countEvents(ongoingInterviews) : '';
        }

        if (mode === 'reports') {
          await this.getNumberOfAssessedCandidates();

          const nonOverallStatuses = ['accepted', 'request_expired'];
          const overall = this.eventsSummary.filter(
            (event: { status: string }) => !nonOverallStatuses.includes(event.status),
          );
          const rejected = overall.filter(
            (event: { status: string }) => event.status === 'rejected',
          );
          const prepared = overall.filter(
            (event: { status: string }) => event.status === 'prepared',
          );
          const assessed = this.assessedCandidates - (prepared[0]?.count ?? 0);
          const drafts = overall.filter((event: { status: string }) => event.status === 'draft');
          const todo = assessed + (rejected[0]?.count ?? 0) + (prepared[0]?.count ?? 0);
          const sent = overall.filter(
            (event: { status: string }) =>
              event.status === 'published' || event.status === 'in_review',
          );

          eventsNumber[0] = overall.length ? this.countEvents(overall) + assessed : '';
          eventsNumber[1] = todo > 0 ? todo : '';
          eventsNumber[2] = drafts.length ? this.countEvents(drafts) : '';
          eventsNumber[3] = sent.length ? this.countEvents(sent) : '';
        }
      } else {
        if (mode === 'projects') {
          const nonOverallStatuses = ['completed', 'cancelled', 'expired', 'invoices_sent'];
          const overall = this.eventsSummary.filter(
            (event: { status: string }) => !nonOverallStatuses.includes(event.status),
          );
          const requests = overall.filter(
            (event: { status: string }) => event.status !== 'confirmed',
          );
          const ongoing = overall.filter(
            (event: { status: string }) => event.status === 'confirmed',
          );

          eventsNumber[0] = overall.length ? this.countEvents(overall) : '';
          eventsNumber[1] = requests.length ? this.countEvents(requests) : '';
          eventsNumber[2] = ongoing.length ? this.countEvents(ongoing) : '';
        }

        if (mode === 'reports') {
          const todo = this.eventsSummary.filter(
            (event: { status: string }) => event.status === 'published',
          );

          eventsNumber[0] = todo.length ? this.countEvents(todo) : '';
        }
      }

      store.commit('setEventsNumber', { eventsNumber, mode });
    },

    findAndApplyActivePassage(eventsNumber, passageNames, store): void {
      const firstGreaterThanZeroIndex = eventsNumber.findIndex((count) => count > 0);

      if (firstGreaterThanZeroIndex !== -1) {
        const activePassageName = passageNames[firstGreaterThanZeroIndex];
        localStorage.setItem('activeUpcomingFilter', activePassageName);

        store.commit('applyTrainingsModeFilter', {
          filter: activePassageName,
          mode: 'upcoming',
        });
      }
    },

    async getEventsList(): Promise<void> {
      if (this.mode === 'reports' && this.reportsFilters.includes(this.filter)) {
        assessmentsService.getReports({ self: this, filter: this.filter });
      } else if (this.mode === 'interviews' && this.interviewsFilters.includes(this.filter)) {
        assessmentsService.getAssessments({ self: this, filter: this.filter });
      } else if (this.mode === 'projects' && this.projectsFilters.includes(this.filter)) {
        assessmentsRequestService.getRequests({ self: this, filter: this.filter });
      } else if (this.mode === 'trainings' && this.trainingsFilters.includes(this.filter)) {
        trainingService.getTrainings({ self: this, filter: this.filter });
      } else if (this.mode === 'upcoming' && this.trainingSessionsFilters.includes(this.filter)) {
        trainingService.getTrainingSessions({ self: this, filter: this.filter });
      } else if (this.mode === 'tasks' && this.tasksFilters.includes(this.filter)) {
        trainingService.getTasks({
          self: this,
          filter: this.filter,
        });
      } else if (this.mode === 'sessions' && this.sessionsFilters.includes(this.filter)) {
        trainingService.getClientTrainingSessions({
          self: this,
          filter: this.filter,
        });
      }
    },

    loadMoreEvents(): void {
      this.getEventsList();
    },

    ifOnPageBottomLoadMoreEvents(): void {
      const d = document.documentElement;
      const offset = d.scrollTop + window.innerHeight;
      const height = d.offsetHeight;

      if (offset >= height) {
        this.loadMoreEvents();
      }
    },

    runLazyLoading(): void {
      this.lazyLoadListener = document.addEventListener(
        'scroll',
        this.ifOnPageBottomLoadMoreEvents,
      );
    },

    countEvents(events: unknown[]): number {
      return events
        .map((event: { count: number }) => event.count)
        .reduce((acc: number, curr: number) => acc + curr);
    },

    getCoAssessors(event: any): any {
      if (this.mode === 'projects') {
        return event.coAssessors;
      } else {
        return event.assessmentObject?.co_assessors;
      }
    },
    getCreatorOfEvent(event: any): any {
      return event.userWhoCreated;
    },
  },
};
